export const BASE_HEIGHT_PX = 86;
export const WEB_BOTTOM_PADDING_PX = 0;
export const PWA_BOTTOM_PADDING_PX = 16;

export const getNavigationBarHeight = (isPWA) => {
    return BASE_HEIGHT_PX + (isPWA ? PWA_BOTTOM_PADDING_PX : WEB_BOTTOM_PADDING_PX);
};

export const getNavigationBarPwaOffset = (isPWA) => {
    return isPWA ? PWA_BOTTOM_PADDING_PX : WEB_BOTTOM_PADDING_PX;
};
